import { render, staticRenderFns } from "./LeadDoubleRequests.vue?vue&type=template&id=56665768&scoped=true&"
import script from "./LeadDoubleRequests.vue?vue&type=script&lang=js&"
export * from "./LeadDoubleRequests.vue?vue&type=script&lang=js&"
import style0 from "./LeadDoubleRequests.vue?vue&type=style&index=0&id=56665768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56665768",
  null
  
)

export default component.exports